import { ImmomioButtonComponent } from '@immomio/ui/button';
import {
  Component,
  input,
  output,
  ChangeDetectionStrategy
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-wizard-footer',
  templateUrl: './wizard-footer.component.html',
  styleUrls: ['./wizard-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ImmomioButtonComponent, TranslatePipe]
})
export class WizardFooterComponent {
  readonly disabled = input<boolean>(undefined);
  readonly hasNext = input<boolean>(undefined);
  readonly hasPrevious = input<boolean>(undefined);
  readonly hasFinish = input<boolean>(undefined);
  readonly hideRequiredHint = input<boolean>(undefined);
  readonly completeActionText = input<string>(undefined);

  readonly nextStep = output();
  readonly previousStep = output();
  readonly completeStep = output();

  public onNextStep() {
    this.nextStep.emit();
  }

  public onPreviousStep() {
    this.previousStep.emit();
  }

  public onCompleteStep() {
    this.completeStep.emit();
  }
}
